import { Box, Grid, Stack, Typography } from '@mui/material';
import { isArray } from 'lodash';
import React, { FC } from 'react';
import VideoCard from './singleVideo';
import { DotLottleLoader } from '../../../../components/Loader';
import { IVideo } from '../../videos/hooks/useFetchVideos';
import { LoadMoreBtn } from '../../../../components/Loader';

interface Props {
  loading?: boolean;
  error?: null | string;
  total: number;
  videos: null | IVideo[];
  loadMore: () => void;
  selectedVideos: Array<number>;
  onVideoSelect: (videoFileId: number) => void;
}
const VideoList: FC<Props> = ({ videos, loading, error, loadMore, total, selectedVideos, onVideoSelect }) => {

  const selectVideo = (video: IVideo) => {
    const id = video.s3_file_id || video.id;
    if (id) onVideoSelect(id);
  };

  const checkIsSelected = (video: IVideo): boolean => {
    const id = video.s3_file_id || video.id || -1;
    return selectedVideos.includes(id);
  }

  if (loading && (!isArray(videos) || videos.length === 0))
    return <DotLottleLoader fill={false} />;

  // fetching videos fail
  if (!isArray(videos) && error)
    return (
      <Typography variant="h4" textAlign="center">
        Error while fetching videos
      </Typography>
    );

  // fetching's succeed but nothing to display
  if (isArray(videos) && videos.length === 0)
    return (
      <Typography variant="h4" textAlign="center">
        There&apos;s nothing to display
      </Typography>
    );

  return (
    <Stack direction="row" alignItems="top">
      <Box
        height="auto"
        maxWidth="auto"
        flexGrow={1}
        sx={{
          overflow: 'hidden',
          paddingRight: '16px',
          marginRight: '16px',
        }}
      >
        <Box sx={{ marginRight: '-30px' }}>
          <Grid container spacing={2} columns={{ xs: 10 }}>
            {Array.isArray(videos) &&
              videos.map((video: IVideo, i) => (
                <Grid item xs={2.46} key={i}>
                  <VideoCard 
                    video={video} 
                    onClick={() => selectVideo(video)} 
                    isSelected={checkIsSelected(video)} 
                  />
                </Grid>
              ))}
          </Grid>
        </Box>
        {Array.isArray(videos) && videos.length < (total || 0) && (
          <LoadMoreBtn onClick={loadMore} loading={loading} />
        )}
      </Box>
    </Stack>
  );
};

export default VideoList;
